module.exports = __webpack_public_path__ + "img/Total Sales 1.dcd552d9.png";